export default __webpack_public_path__ + "static/media/ic_frax_24.713cbe16.svg";